"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MouseSystem = void 0;
const InputSystem_1 = require("../InputSystem");
class MouseSystem extends InputSystem_1.InputSystem {
    constructor(state) {
        super(state);
        this.actionsFinished = [];
        this.actionsStarted = [];
        this.handleMouseDown = this.handleMouseDown.bind(this);
        this.handleMouseUp = this.handleMouseUp.bind(this);
        this.handleMouseMove = this.handleMouseMove.bind(this);
        window.addEventListener('mousedown', this.handleMouseDown);
        window.addEventListener('mouseup', this.handleMouseUp);
        window.addEventListener('mousemove', this.handleMouseMove);
    }
    updateState() {
        this.actionsFinished.forEach(a => {
            this.actionState[a] = false;
        });
        this.actionsStarted.forEach(a => {
            this.actionState[a] = true;
        });
        this.actionsStarted.length = 0;
        this.actionsFinished.length = 0;
    }
    handleMouseMove(event) {
    }
    handleMouseDown(event) {
        const actions = this.resolveActions(event.button);
        actions && this.actionsStarted.push(...actions);
    }
    handleMouseUp(event) {
        const actions = this.resolveActions(event.button);
        actions && this.actionsFinished.push(...actions);
    }
    onClear() {
        window.removeEventListener('mousedown', this.handleMouseDown);
        window.removeEventListener('mouseup', this.handleMouseUp);
        window.removeEventListener('mousemove', this.handleMouseMove);
    }
}
exports.MouseSystem = MouseSystem;
//# sourceMappingURL=module.js.map